<template>
  <div>
    <div></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      departments: [],
    };
  },
};
</script>
